export class DateUtils {

  // Returns the current date in YYYY-MM-DD format.
  public static currentDate(): string {
    return DateUtils.formatAsIsoDate(new Date());
  }

  // Formats a date as YYYY-MM-DD
  public static formatAsIsoDate(d: Date | string): string {
    if (typeof d === "string") {
      d = new Date(d);
    }
    return (<any>d instanceof Date && !isNaN(d.getTime()) ? formatYear(d) + "-" + formatMonth(d) + "-" + formatDay(d) : null);
  }

  // Formats a date as DD.MM.YYYY
  public static formatAsLocalDate(d: Date | string): string {
    if (typeof d === "string") {
      d = new Date(d);
    }
    return (<any>d instanceof Date && !isNaN(d.getTime()) ?  formatDay(d) + "." + formatMonth(d) + "." + formatYear(d) : null);
  }

}

function formatYear(d: Date): string {
  return ("0000" + d.getFullYear()).slice(-4);
}

function formatMonth(d: Date): string {
  return ("0" + (d.getMonth() + 1)).slice(-2);
}

function formatDay(d: Date): string {
  return ("0" + d.getDate()).slice(-2);
}
